import React from "react";
import {AutoSizer, Grid} from "react-virtualized";
import PropTypes from "prop-types";

import FeaturesSetupFeature from "./FeaturesSetupFeature/FeaturesSetupFeature";
import {useWindowSize} from "../../utilities/helperHooks";
import {featureInterface} from "./FeaturesSetupFeature/featureInterface";

const FEATURE_WIDTH = 596; // 580 + 16 margin
const FEATURE_HEIGHT = 148; // 132 + 16 margin

const addDisabledSpacer = (featuresList, gridColumnCount) => {
  let allFeatures = [...featuresList];
  // we update isEnabled property on load and on demand (to prevent jumping)
  const enabledFeatures = allFeatures.filter(dbFeature => dbFeature.isEnabled);
  const disabledFeatures = allFeatures.filter(dbFeature => !dbFeature.isEnabled);

  if (enabledFeatures.length < 1 || disabledFeatures.length < 1) {
    return allFeatures
  }

  let disabledSpacer = [];
  if (disabledFeatures.length > 0) {
    let remainder = enabledFeatures.length % gridColumnCount;
    if (remainder > 0) {
      for (let i = 0; i < gridColumnCount - remainder; i++) {
        disabledSpacer.push(null);
      }
    }
    disabledSpacer.push("disabledLine");
    for(let i = 0; i < gridColumnCount - 1; i++) {
      disabledSpacer.push(null);
    }
  }
  return [...enabledFeatures, ...disabledSpacer, ...disabledFeatures]
}

const FeaturesSetupVirtualizedGrid = (props) => {

  let {featuresList, setCurrentScroll} = props;
  const windowSize = useWindowSize();

  const gridColumnCount = windowSize.width < 1024 ? 1 : Math.floor((windowSize.width - 64) / FEATURE_WIDTH);

  const allFeatures = addDisabledSpacer(featuresList, gridColumnCount);

  const gridRowCount = Math.ceil(allFeatures.length / gridColumnCount);
  // const gridColumnWidth = windowSize.width < 1024 ? windowSize.width - 32 : FEATURE_WIDTH;
  // console.log("gridColumnCount", gridColumnCount);
  // console.log("gridRowCount", gridRowCount);
  // console.log("gridColumnWidth", gridColumnWidth);

  const gridItemRenderer = ({columnIndex, key, rowIndex, style}) => {
    let index = (gridColumnCount * rowIndex) + columnIndex;
    let feature = allFeatures[index];
    if (!feature) {
      return null
    }
    let mutableStyle = {...style};
    if (feature === "disabledLine") {
      mutableStyle.height = 80;
      mutableStyle.width = "100%";
      mutableStyle.top = mutableStyle.top + 26;
      return (
        <div style={mutableStyle} key={key}>
          <h2 className="project-scope-disabled-subheader">Disabled Features</h2>
        </div>
      );
    }
    return (
      <div style={style} key={key}>
        <FeaturesSetupFeature feature={feature} />
      </div>
    )
  }

  const onGridScroll = (props) => {
    if (setCurrentScroll) {
      const {scrollTop} = props;
      // console.log("scrollTop", scrollTop);
      setCurrentScroll(scrollTop)
    }
  };

  const overscanIndicesGetter = ({
                                   // direction, // One of "horizontal" or "vertical"
                                   cellCount, // Number of rows or columns in the current axis
                                   // scrollDirection, // 1 (forwards) or -1 (backwards)
                                   overscanCellsCount, // Maximum number of cells to over-render in either direction
                                   startIndex, // Begin of range of visible cells
                                   stopIndex, // End of range of visible cells
                                 }) => {
    return {
      overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex),
    };
  }

  return (
    <div className="fs-list">
      <AutoSizer>
        {({width, height}) => (
          <Grid
            onScroll={onGridScroll}
            cellRenderer={gridItemRenderer}
            columnCount={gridColumnCount}
            columnWidth={FEATURE_WIDTH}
            width={width}
            height={height + 90}
            rowCount={gridRowCount}
            rowHeight={FEATURE_HEIGHT}
            overscanRowCount={1}
            overscanIndicesGetter={overscanIndicesGetter} // this prevents hiding top row on scroll down beforehand
          />
        )}
      </AutoSizer>
    </div>
  )
};

FeaturesSetupVirtualizedGrid.propTypes = {
  setCurrentScroll: PropTypes.func,
  featuresList: PropTypes.arrayOf(PropTypes.shape(featureInterface)),
}

export default FeaturesSetupVirtualizedGrid
